import { render, staticRenderFns } from "./AboutPollingData.vue?vue&type=template&id=2efe6bf7&"
import script from "./AboutPollingData.vue?vue&type=script&lang=js&"
export * from "./AboutPollingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports